import { ContentExternalDocumentTypeEnum, ContentTypeEnum } from 'features/contents';

const contentsTypes = (contentType: ContentTypeEnum = ContentTypeEnum.Video, externalDocumentType?: ContentExternalDocumentTypeEnum) => {
  const contentTypes = [{ slug: 'undefined' }, { slug: 'video' }, { slug: 'article' }, { slug: 'quiz' }, { slug: 'scorm' }, { slug: 'survey' }];

  const externalDocumentTypes = [{ slug: 'undefined' }, { slug: 'pdf' }, { slug: 'audio' }];

  if (externalDocumentType) return externalDocumentTypes[externalDocumentType]?.slug;

  return contentType && contentTypes[contentType]?.slug;
};

export default contentsTypes;
